export default __webpack_public_path__ + "static/img/logo-lokomotive-yellow.4f27eb8.png";